<template>
	<div class="allReport">
		<div class="load" v-if="loading" v-loading="loading" :element-loading-text="name+'同学您好 ，你的成绩单数据计算中，稍等几秒钟哦～...'"
		 element-loading-spinner="el-icon-loading" element-loading-background="rgba(255, 255, 255, 0.8)"></div>
		<div class="report-but" :style="printCustom?'':'display:none'">
			<el-button type="goon" size="small" @click="printReport()">生成成绩单</el-button>
			<el-button @click="reLoad" type="reload" size="small">重置</el-button>
		</div>
		<div class="pop-text" v-if="popReport">
			<i v-if="getDetailList.length&&!reportMake" class="el-icon-loading" style="font-size:33px;font-weight:300"></i>
			<span v-if="getDetailList.length&&!reportMake">正在生成自定义成绩单</span>
			<span v-if="!getDetailList.length||reportMake">请先点击自定义生成悬浮按钮，再选择打印按钮</span>
		</div>
		<div style="position: absolute; right: 10px; top: 10px; z-index: 99999">
			<el-button type="goon" title="建议预览目标打印机为:导出为WPS PDF" class="btn" size="mini" @click="print">打印</el-button>
			<!-- <el-button class="btn" size="mini" type="primary" @click="quit">退出</el-button> -->
			<el-button class="btn" size="mini" type="cancelIt" @click="checkbtn">回到上一页</el-button>
			<el-button class="btn" size="mini" type="cancelIt" @click="quit">退出</el-button>
		</div>
		<div class="first-pagereport print">
			<div style="position:absolute; right: 10px; top: 10px; z-index:9">
				<div id="qrCode" ref="qrCode"></div>
			</div>
			<div class="top-content" style="height:168px">
				<div class="avatar">
					<el-row>
						<el-col :span="4" style="width: 215px;">
							<img style="object-fit: contain;width: 200px" :src="users.origLogo" alt="" />
						</el-col>
					</el-row>
				</div>
				<div class="title_line">
					<span> 第二课堂成绩单</span>
					<span class="english">THE CLASS EXTRA TRANSCRIPTS</span>
				</div>

			</div>
			<div class="home-info" style="position: relative;top: -80px;">
        <div class="title-img-info">
					<span>
						<img class="top_img" src="../images/top_2.png" alt="">
					</span>
					<span><b>基础信息</b></span>
				</div>
				<!-- <div class="score">
          总成绩：{{ users.hours }}积分/{{ users.collectMinHours }}积分
        </div> -->
				<el-row>
					<el-col :span="7" class="reporthead-photo" style="width:auto">
						<img v-if="!users.cardPhoto && !users.gender" style="object-fit:cover;" class="id-photo" src="../images/teacher-boy.png"
						 alt="" />
						<img v-if="users.cardPhoto" style="object-fit:cover;" class="id-photo" :src="users.cardPhoto" />
						<img v-if="!users.cardPhoto && users.gender == 1" style="object-fit:cover;" class="id-photo" src="../images/teacher-boy.png" />
						<img v-if="!users.cardPhoto && users.gender == 2" style="object-fit:cover;" class="id-photo" src="../images/teacher-girl.png" />
						<img v-if="users.gender == 1" style="object-fit:cover;" class="icon_img" src="../images/boy_icon.png" />
						<img v-if="users.gender == 2" style="object-fit:cover;" class="icon_img" src="../images/girl_icon.png" />

					</el-col>
					<el-col :span="7" style="margin-right: 40px;">
						<div class="basic-info">
							<div class="ba">
								<span class="tag_title">姓名:</span>{{ users.name }}
							</div>
							<div class="ba">
								<span class="tag_title"> 学号:</span>{{ users.code }}
							</div>
							<div class="ba">

								<span class="tag_title"> 性别:</span>{{ users.gender == 1 ? "男" : "女" }}
							</div>
							<div style="display: flex;" class="ba">
								<span style="width: 235px;word-wrap: break-all;display: inline-block;">
									<span class="tag_title">政治面貌:</span>{{
                  users.politics == 4
                    ? "预备党员"
                    : users.politics == 3
                    ? "其他党派"
                    : users.politics == 2
                    ? "党员"
                    : users.politics == 1
                    ? "团员"
                    : "群众"
                }}</span>
							</div>
						</div>
					</el-col>
					<el-col :span="10" style="box-sizing: border-box; padding-left: 0px">
						<div class="score-info">
							<div class="ba">
								<span class="tag_title">院系:</span>{{ users.departmentName }}
							</div>
							<div style="display: flex;" class="ba">
								<span style="width: 235px;word-wrap: break-all;display: inline-block;">
									<span class="tag_title">专业:</span>{{ users.majorName }}</span>
							</div>

							<div class="ba">
								<span class="tag_title"> 年级:</span>{{ users.grade }}
							</div>
							<div class="ba">
								<!-- <span class="tag_title">成绩单日期:</span> {{ getdate() }} -->
								<span class="tag_title">班级:</span>{{ users.className }}

							</div>

						</div>
					</el-col>
				</el-row>
			</div>
			<div class="home-info">
				<div class="title-img-info">
					<span>
						<img class="top_img"  src="../images/top_3.png" alt="">
					</span>
					<span><b>能力模型</b></span>
				</div>
				<div class="pop-info">
					<div class="pop-container">


						<div class="chart-table">
							<el-row>
								<el-col :span="12">
									<div style="margin-left: 5px;font-size: 12px;;color:#3C3D47">
										图表：用户个人能力
									</div>
									<div id="starline" style="height:335px; width:335px; margin-left: 30px"></div>
								</el-col>
								<el-col :span="12">
                  <div style="font-size: 12px;color:#3C3D47">
                    <span style="font-size: 12px;color:#3C3D47">图表： 模块绩点</span>
                  </div>
                  <div class="ry_data_bottom">
                    <table style="font-size: 12px; width:100%"
                           border="0"
                           class="table_ins"
                           cellpadding="0"
                           cellspacing="0">
                      <tr style="background:#F1F1F5;">
                        <th style="width:4rem">模块名称</th>
                        <th>预警类型</th>
                        <th>学时要求</th>
                        <th style="width:8rem">模块/子类/绩点</th>
                      </tr>
                      <tr v-for="(item,index) in finishList"
                          :key="index">
                        <td>{{item.name}}</td>
                        <td>
                          <!-- <span v-if="item.termHours">{{item.termHours}}</span> -->
                          <span>{{item.subclassName}}</span>
                        </td>
                        <td>{{item.minHours}}</td>
                        <td style="color:#0bd699">
                          <span>{{item.userValue}}/{{item.subclassHours}}/{{item.gpa}}</span>
                        </td>
                      </tr>
                    </table>
                  </div>
<!--									<div id="circle" style="height:335px; width:335px; margin-left: 30px"></div>-->
<!--									<div class="noData" v-if="show&&isShow==2">-->
<!--										<img src="../images/nocircel.png" />-->
<!--										暂无数据</div>-->
								</el-col>
							</el-row>
						</div>
					</div>
				</div>
			</div>


			<div class="home-info">
				<div class="title-img-info">
					<span>
						<img class="top_img" src="../images/top_2.png" alt="">
					</span>
					<span style="position: relative;"><b>学期{{hoursUnit}}</b>
<!--						<span style="color:#606774;font-size:14px;bottom: 40px;left: 132px;">-->
<!--							第二课堂成绩-->
<!--							<span>-->
<!--              <span v-if="isreach" style="color:#0E9E5F">达标</span>-->
<!--              <span v-else style="position: relative;right: 4px;color:red">不达标</span>-->
<!--            </span>-->
<!--						</span>-->
					</span>
				</div>

        <div class="chart-table">
          <div class="">
            <span>已获得:{{ users.hours }}{{ hoursUnit }}</span>
            <span style="color:#FF6410">（={{ avgGpa }}绩点）</span>
          </div>
          <div style="width:100%;margin-top:10px;" class="termYears">
            <div class="" style="width: 339px;">
              <table border="0" class="table_in" cellpadding="0" cellspacing="0">
                <tr style="background:#F1F1F5;">
                  <th>学年</th>
                  <th>{{hoursUnit}}</th>
                </tr>
                <tr v-for="(item,index) in termHours" :key="index">
                  <td>{{item.date1}}</td>
                  <td>
                    <span v-if="item.termHours">{{item.termHours}}</span>
                    <span v-else>暂无</span>
                  </td>
                </tr>
              </table>
            </div>
            <div class="gz">
              <p style="text-align: center">共青团安庆师范大学委员会</p>
              <p>根据《安庆师范大学第二课堂学时管理办法(试 行)》,{{ users.name }}同学的第二课堂综合评价结果为<span class="gz_jd">{{ result }}</span></p>
            </div>
          </div>
        </div>
			</div>
<!--      	<div class="seal" style="position: absolute;right:60px;bottom:140px;">-->
<!--          <div class="seal-center" v-if="users.showSealName1">-->
<!--            <img v-if="SwalNameurl1" class="seal_img1" :src="SwalNameurl1" alt="" />-->
<!--            <div v-else class="seal_name">-->
<!--              {{ users.showSealName1 }}<br/>（盖章）-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="seal-center" v-if="users.showSealName2" style="position: relative;left:25px;">-->
<!--            <img v-if="SwalNameurl2" class="seal_img2" :src="SwalNameurl2" alt="" />-->
<!--            <div v-else class="seal_name">-->
<!--              {{ users.showSealName2 }}<br/>（盖章）-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
			<div class="bottom-line">
				<p></p>
				<div>
					<span><img :src="users.origLogo" style="width:100px;object-fit: contain;height:25px;position: relative;right: 19px;" /></span>
					<span>第1页</span>
				</div>
				<p></p>
			</div>
		</div>
		<!-- second-page print -->
		<div class="first-pagereport print print-3" style="margin-top: 70px;">
			<div class="top-content" style="height:108px">
				<div class="avatar">
					<el-row>
						<el-col :span="4">
							<img style="
              visibility: hidden;
               width: 215px;
                object-fit: contain;
                "
							 src="../images/logo2.png" alt="" />
						</el-col>
					</el-row>
				</div>
				<div class="title_line">
					<span> 第二课堂成绩单</span>
					<span class="english">THE CLASS EXTRA TRANSCRIPTS</span>
				</div>
			</div>
			<div class="home-info">
				<div class="title-img-info">
					<span>
						<img class="top_img" src="../images/top_1.png" alt="">
					</span>
					<span><b>学年{{hoursUnit}}详情</b> <span v-if="reportMake" class="report_line showtips">（当前为全部数据,您还可以选择
							<u @click="printCustomClick" style="cursor: pointer;" :style="printCustom?'color:#606774':'color:#0bd699'">{{printCustom?'取消自定义':'自定义成绩单'}}</u>）</span>
						<span v-if="switchTips&&!reportMake" :class="valueshow?'':'showtips'" class="report_line">tips:此自定义成绩单详情为该生成绩单部分详情；<el-switch
							 class="showtips" style="cursor: pointer;" v-model="valueshow" active-color="#0bd699" :active-text="valueshow?'显示tips':''"
							 inactive-color="#E0E0E1"></el-switch></span>
					</span>
				</div>
				<div :class="printCustom?'report-lists':''">
					<el-table :data="termDetail.slice(0, 12)" :header-cell-style="{ 'text-align': 'center' }" :cell-style="{ 'text-align': 'center' }"
					 border class="detail-table" :span-method="objectSpanMethod" style="width: 100%;  margin-top: 20px">
						 
						<el-table-column prop="termName" label="学年学期">
							<p style="padding: 0px 0px 0 17px;text-align: center;line-height: 21px;" slot-scope="scope">
								{{ scope.row.termName }}
							</p>
							          
						</el-table-column>   <el-table-column width="150px" prop="classifyName" label="分类名称">
							<p style="padding: 0px 0px 0 13px;text-align: left;line-height: 18px;" slot-scope="scope">
								{{ scope.row.classifyName }}
							</p>
							          
						</el-table-column>   
						<el-table-column width="200px " prop="sourceTypeName" label="认定明细">  
							<p slot-scope="scope" style="padding: 0px 0px 0 14px;text-align: left;line-height: 18px;">
								{{ scope.row.sourceTypeName }}
							</p>
							                   </el-table-column>
						<el-table-column width="90px" prop="hours" :label="hoursUnit">
							 <p slot-scope="scope" style="padding:0 6px 0 0;color:#FF6410">
								<span v-if="scope.row.sourceType==4">
									-{{ scope.row.hours }}
								</span>
								<span v-else>
									+{{ scope.row.hours }}
								</span>
								  
							</p>
							          </el-table-column>
						<el-table-column prop="time" label="获得时间">
							<p style="padding: 0 0px 0 2px;width: 116px;font-size: 13px;" slot-scope="scope">{{scope.row.time |formatDate}}</p>
							          
						</el-table-column>  
					</el-table>
					<div class="report_cover" :style="printCustom?'':'display:none'">
						<div style="position: relative;top: 7px;" @click="pageClick(1,termDetail.slice(0, 12),'termDetail')">
							<span v-if="allChoose==1"> <img src="../images/createactivity_cancelthechoice@2x.png" alt=""></span>
							<span v-else class="report_choose"></span>
						</div>
						<div v-for="(item,index) in termDetail.slice(0, 12)" :key="index" @click="chooseIt(item,1)">

							<span v-if="customId&&customId.includes(item.id)"> <img src="../images/createactivity_cancelthechoice@2x.png"
								 alt=""></span>
							<span v-else class="report_choose"></span>
						</div>
					</div>
				</div>

			</div>


			<div class="bottom-line">
				<p></p>
				<div>
					<span> <img :src="users.origLogo" style="width:100px;
          object-fit: contain;
          height:25px;
          position: relative;
          right: 19px;" /></span>
					<span>第2页</span>
				</div>
				<p></p>
			</div>
		</div>


		<!-- 第3页码 -->
		<div v-show="data2.length!=0">
			<div v-for="(it, index) in count" :key="index" class="first-pagereport print print-3" style="margin-top: 70px;">
				<div class="top-content" style="height:108px">
					<div class="avatar">
						<el-row>
							<el-col :span="4" style="width: 215px;">
								<img style="object-fit: contain;visibility: hidden;" :src="users.origLogo" alt="" />
							</el-col>
						</el-row>
					</div>
					<div class="title_line">
						<span> 第二课堂成绩单</span>
						<span class="english">THE CLASS EXTRA TRANSCRIPTS</span>
					</div>
				</div>
				<div class="home-info">
					<div class="title-img-info">
						<span>
							<img class="top_img" src="../images/top_1.png" alt="">
						</span>
						<span><b>学年{{hoursUnit}}详情</b></span>
					</div>
					<div v-if="data2.length!=0" :class="printCustom?'report-lists':''">
						<el-table
                :data="data2.slice(index*12,it*12)"
                :header-cell-style="{ 'text-align': 'center' }"
                :cell-style="{ 'text-align': 'center' }"
                border
                :span-method="(param)=>objMethod(param,index)"
						 class="detail-table" style="width: 100%;  margin-top: 20px">
							 
							<el-table-column prop="termName" label="学年学期">
								<p style="padding: 0px 0px 0 17px;text-align: center;line-height: 21px;" slot-scope="scope">
									{{ scope.row.termName }}
								</p>
								          
							</el-table-column>   <el-table-column width="150px" prop="classifyName" label="分类名称">
								<p style="padding: 0px 0px 0 13px;text-align: left;line-height: 18px;" slot-scope="scope">
									{{ scope.row.classifyName }}
								</p>
								          
							</el-table-column>   
							<el-table-column width="200px " prop="sourceTypeName" label="认定明细">  
								<p slot-scope="scope" style="padding: 0px 0px 0 14px;text-align: left;line-height: 18px;">
									{{ scope.row.sourceTypeName }}
								</p>
								                   </el-table-column>
							<el-table-column width="90px" prop="hours" :label="hoursUnit">
								 <p slot-scope="scope" style="padding:0 6px 0 0;color:#FF6410">
									<span v-if="scope.row.sourceType==4">
										-{{ scope.row.hours }}
									</span>
									<span v-else>
										+{{ scope.row.hours }}
									</span>
									  
								</p>
								          </el-table-column>
							<el-table-column prop="time" label="获得时间">
								<p style="padding: 0 0px 0 2px;width:116px;font-size: 13px;" slot-scope="scope">{{scope.row.time |formatDate}}</p>
								          
							</el-table-column>  
						</el-table>
						<div class="report_cover" :style="printCustom?'':'display:none'">
							<div style="position: relative;top: 7px;" @click="pageClick(2,data2.slice(index*12,it*12),index)">
								<span v-if="allChoose2==2&&indexChoose&&indexChoose.includes(index)"> <img src="../images/createactivity_cancelthechoice@2x.png"
									 alt=""></span>
								<span v-else class="report_choose"></span>
							</div>
							<div v-for="(item,key) in data2.slice(index*12,it*12)" :key="key" @click="chooseIt(item,2,index)">
								<span v-if="customId&&ids.includes(item.id) "> <img src="../images/createactivity_cancelthechoice@2x.png" alt=""></span>
								<span v-else class="report_choose"></span>
							</div>
						</div>
					</div>

				</div>


				<div class="bottom-line">
					<p></p>
					<div>
						<span> <img :src="users.origLogo" style="width:100px;
          object-fit: contain;
          height:25px;
          position: relative;
          right: 19px;" /></span>
						<span>第{{index+3}}页</span>
					</div>
					<p></p>
				</div>
			</div>


		</div>

	</div>
</template>
<script>
	import TableV from "@/components/TableW.vue";
  import QRCode from 'qrcodejs2'
	import echarts from 'echarts';
	import {
		formatDate
	} from '@/components/formDate.js';
	const animationDuration = 3000;
	import {
		UserApi
	} from "@/api";

	export default {
		filters: {
			formatDate(time) {
				var date = new Date(time);
				return formatDate(date, 'yyyy-MM-dd hh:mm');
			}
		},
		data() {
			return {
        finishList:[],//各模块绩点表
        avgGpa:'',//平均绩点
        result:'',//平均绩点对应的结果
        SwalNameurl1:'',
        SwalNameurl2:'',
        isreach:false,
				printCustom: false,
				reportMake: true,
				switchTips: false,
				valueshow: true,
				customId: '',
				moreDatashow: true,
				ids: [],
				getDetailList: [], //存放所有数据
				gettermHours: [], //临时存放
				popReport: false,
				termDetail: [],
				qrCodeDialogVisible: false,
				afterDataHours: [],
				afterData: [],
				show: false,
				isShow: 1,
				hoursUnit: localStorage.getItem('hoursUnit'),
				data1: [],
				data2: [],
				getpass: '',
				name: localStorage.getItem('name'),
				nopass: '',
				operatorId: localStorage.getItem('operatorId'),
				reportUrl: localStorage.getItem('reportUrl'),
				schoolId: localStorage.getItem('schoolId'),
				spanArray: [],
				sortArray: [],
				count: 1,
				countitem: 11,
				numCount: 0,
				//  学年学时详情

				users: {},
				classifyData: [],
				maxValue: [{
						name: "思想素养",
						max: 1,
					},
					{
						name: "文化活动",
						max: 1,
					},
					{
						name: "技能特长",
						max: 1,
					},
					{
						name: "志愿公益",
						max: 1,
					},
					{
						name: "创新创业",
						max: 1,
					},
				],
				termHours: [],
				allChoose: '',
				allChoose2: '',
				indexList: [],
				indexChoose: '',
				myValue: [0, 0, 0, 0, 0],
				schoolValue: [],
				modelStar: 5,
				termList: [{
					termYear: '2020~2021学年',
					hours: '80'
				}, {
					termYear: '2020~2021学年',
					hours: '80'
				}, {
					termYear: '2020~2021学年',
					hours: '80'
				}, {
					termYear: '2020~2021学年',
					hours: '80'
				}, {
					termYear: '2020~2021学年',
					hours: '80'
				}],
				personStar: null,
				activeData: [],
				loading: true,
				radar: false,
			};
		},
		components: {
			TableV,
		},
		watch: {
			classifyData(val) {
				this.classifyData = val
				this.classifyData.forEach((item, index) => {
					if (item.id > item.min || item.id == item.min) {
						this.getpass = 1
					} else {
						this.nopass = 1
					}
				})

			},
		},
		computed: {
			groupNum() {
				//获取分组数据
				return new Set(this.termDetail.slice(0, 12).map((o) => o.termName));
			},
      numSubscript() {
        return function (index){
          //获取分组数据
          if (index == 0){
            return new Set(this.data2.map((o) => o.termName));
          }else{
            return new Set(this.data2.slice(12 * index, this.data2.length).map((o) => o.termName));
          }
        }
      },
		},

		created() {
			this.getDetail();
		},
		mounted: function() {
			this.getActive();
			// this.inCirlce()
			this.initData();
      this.qrCodeCreate()
			// setTimeout(function(){
			//   	},6000)
		},
		methods: {
      objMethod({row, column, rowIndex, columnIndex},index) {
        if (columnIndex == 0) {
          const len = this.nameGrouptw(row.termName,index);
          const lenName = this.nameLentw(row.termName,index);
          if (rowIndex === lenName) {
            return {
              rowspan: len,
              colspan: 1,
            };
          } else
            return {
              rowspan: 0,
              colspan: 0,
            };
        } else {
          return {
            rowspan: 1,
            colspan: 1,
          };
        }
      },
			pageClick(val, data, index) { //选择本页所有的数据
				if (this.allChoose == 1 && index == 'termDetail') { //第一页取消全部选中
					this.allChoose = ''
					this.setSplice(data, 2)
				} else if (this.allChoose2 == 2 && this.indexChoose.includes(index)) { //其他页取消全选
					this.indexList.splice(this.indexList.indexOf(index), 1)
					this.indexChoose = this.indexList.join(',')
					this.setSplice(data, 2)
				} else { //当前页面全部选中
					if (val == 1) {
						this.allChoose = val
					} else {
						this.allChoose2 = val
						this.indexList.push(index)
						this.indexChoose = this.indexList.join(',')
					}
					this.setSplice(data, 1)
				}
			},
			setSplice(data, val) { //获取和取消选中数据
				data.forEach((item, index) => {
					this.getDetailList.forEach(its => {
						if (its.id == item.id) {
							this.ids.splice(this.ids.indexOf(item.id), 1)
							this.getDetailList.splice(this.getDetailList.indexOf(item), 1)
						}
					})
					this.termDetail.forEach(it => {
						if (it.id == item.id) {
							if (val == 2) {
								this.ids.splice(this.ids.indexOf(item.id), 1)
								this.getDetailList.splice(this.getDetailList.indexOf(item), 1)
							} else {
								this.ids.push(item.id)
								this.getDetailList.push(item)
							}
						}
					})
				})
				this.customId = this.ids.join(',')
			},
			printCustomClick() {
				if (this.printCustom) {
					this.printCustom = false
					this.switchTips = false
				} else {
					this.printCustom = true
					this.switchTips = true
				}
			},
			chooseIt(item, val, index) {
				if (this.customId.includes(item.id)) {
					this.ids.splice(this.ids.indexOf(item.id), 1)
					this.getDetailList.splice(this.getDetailList.indexOf(item), 1)
					if (val == 1) {
						this.allChoose = ''
					} else {
						this.indexList.splice(this.indexList.indexOf(index), 1)
						this.indexChoose = this.indexList.join(',')
					}
				} else {
					this.ids.push(item.id)
					this.getDetailList.push(item)
				}
				this.customId = this.ids.join(',')
			},
			reLoad() {
				this.getDetailList = []
				this.ids = []
				this.customId = ''
			},
			printReport() { //生成成绩单
				if (this.getDetailList.length) {
					this.popReport = true
					this.reportMake = false
					setTimeout(item => {
						this.popReport = false
						this.printCustom = false
					}, 1000)
					let cache = {};
					let indices = [];
					this.getDetailList.map((item, index) => {
						let termName = item.termName;
						let _index = cache[termName];
						if (_index !== undefined) {
							indices[_index].push(index)
						} else {
							cache[termName] = indices.length
							indices.push([index])
						}
					})
					let result = [];
					indices.map((item) => {
						item.map((index) => {
							result.push(this.getDetailList[index])
						})
					})
					this.getDetailList = result
					this.termDetail = this.getDetailList
					if (Math.ceil(this.getDetailList.length / 12) - 1 > 0) {
						this.count = Math.ceil(this.getDetailList.length / 12) - 1;
					}
					this.data2 = this.getDetailList.slice(12, this.getDetailList.length)
					this.numCount = Math.floor(this.data2.length / 12)

					console.log(this.count, this.data2, "this.count")
				} else {
					this.$message.error('请先勾选您想打印的数据');
				}
			},
			//关闭弹框清除二维码
			qrCodeHandleClose() {
				this.qrCodeDialogVisible = false;
				this.qrCode = '';
				document.getElementById('qrCode').innerHTML = '';
			},
			//创建二维码
			qrcode(url) {
				this.qrCode = new QRCode('qrCode', {
					text: url,
					width: 80,
					height: 80
				})
			},
			qrCodeCreate() {
				let url = ''
				url = this.reportUrl + this.schoolId + "/" + this.operatorId
        console.log(url)
				this.$nextTick(() => {
					this.qrcode(url);
				})
			},
			//二维码显示
			qrCodeOpen(val) {
				//   http://localhost:8080/#/sureReport/10002/899144
				//  this.qrCodeDialogVisible = true;
				url = this.reportUrl + this.schoolId + "/" + this.operatorId
				window.open(url);
			},
			nameGroup(name) {
				return this.termDetail.slice(0, 12).filter((o) => o.termName == name).length;
			},
      nameGrouptw(name,index) {
        // 获取相同名称的数量
        if (index == 0){
          return this.data2.filter((o) => o.termName == name).length;
        }else if (index == 1){
          return this.data2.slice(12, this.data2.length).filter((o) => o.termName == name).length;
        }else {
          return this.data2.slice(12 * index, this.data2.length).filter((o) => o.termName == name).length;
        }
      },
			nameGroupth(name) {
				// 获取相同名称的数量
				return this.data2.slice(12, this.data2.length).filter((o) => o.termName == name).length;
			},
      nameLentw(name,indexs) {
        const tmp = Array.from(this.numSubscript(indexs));
        const index = tmp.indexOf(name);
        let len = 0;
        for (let i = 0; i < index; i++) {
          len += this.nameGrouptw(tmp[i],indexs);
        }
        return len;
      },
			nameLen(name) {
				const tmp = Array.from(this.groupNum);
				const index = tmp.indexOf(name);
				let len = 0;
				for (let i = 0; i < index; i++) {
					len += this.nameGroup(tmp[i]);
				}
				return len;
			},
			objectSpanMethod(data) {
				const {
					row,
					rowIndex,
					columnIndex
				} = data;
				if (columnIndex == 0) {
					const len = this.nameGroup(row.termName);
					const lenName = this.nameLen(row.termName);
					if (rowIndex === lenName) {
						return {
							rowspan: len,
							colspan: 1,
						};
					} else
						return {
							rowspan: 0,
							colspan: 0,
						};
				} else {
					return {
						rowspan: 1,
						colspan: 1,
					};
				}
			},
			quit() {
				localStorage.clear("sessionKey");
				localStorage.clear("schoolLogo");
				localStorage.clear("identity");
				localStorage.clear("avatar");
				localStorage.clear("operatorId");
				this.$router.push("/login");
			},
			inCirlce() {
				const option = {
					tooltip: {
						trigger: "item",
						formatter: "{a} <br/>{b} : {c} ({d}%)",
					},
					legend: {
						top: "bottom",
						icon: "circle",
						itemWidth: 9, // 设置宽度
						padding: [40, 0, 0, 0],
						textStyle: {
							fontSize: 12,
							color: "#9395AB",
						},
						itemHeight: 9, // 设置高度
						formatter: (value) => {
							var target;
              var title=''
              if (value.length>6){
                title = value.slice(0,6)+'.'
              }else {
                title = value
              }
							for (var j = 0; j < this.classifyData.length; j++) {
								if (this.classifyData[j].label === value) {
                  if (this.schoolId!=10710){
                    target = this.classifyData[j].id + '/' + this.classifyData[j].min
                  }else {
                    target = this.classifyData[j].id + '/' + this.classifyData[j].min+ '/' +this.classifyData[j].rtScore+ '/' +this.classifyData[j].minScore
                  }
								}
							}
              var arr = [title+'\n'+ "(" + target + ")"];
							return arr
						}
					},
					color: [
						"#5599FF",
						"#846cde",
						"#DE26FF",
						"#FF42A4",
						"#02DBAC",
						"#F4A460",
						"#DDA0DD ",
					],
					series: [{
						name: this.hoursUnit + "分布",
						type: "pie",
						radius: ["0", "40%"],
						center: ["50%", "39%"],
						label: {
							show: true, //饼图图形上的文本标签
							normal: {
								show: true,
								textStyle: {
									fontWeight: 300,
									fontSize: 12, //文字的字体大小
								},
								formatter: (value) => {
									var strlength = value.name.length + 4;
									if (value.percent != 0) {
										if (strlength > 5) {
											value.name = value.name.replace(/\S{5}/g, function(match) {
												return match + '\n'
											})
										}
										return value.name + value.percent + '%'
									}
								}
							},
						},
						labelLine: {
							show: true,
							length2: 5,
							length: 10,
						},
						data: this.fillterData,
						emphasis: {
							itemStyle: {
								shadowBlur: 10,
								shadowOffsetX: 0,
								shadowColor: 'rgba(0, 0, 0, 0.5)'
							}

						}
					}]
				};
				const dom = echarts.init(document.getElementById('circle'))

				dom.setOption(option);
				window.addEventListener('resize', function() {
					dom.resize();
				});
			},

			initData() {
				const option = {
					tooltip: {

					},
					title: {
						text: ''
					},
					grid: {
						position: 'center',
					},
					legend: {
						data: [this.hoursUnit + '分布'],
						icon: "circle",
						orient: 'horizontal',
						itemWidth: 9, // 设置宽度
						textStyle: {
							fontSize: 12,
						},
						x: 'center',
						y: 'bottom',
					},
					radar: {
						// shape: 'circle',
						name: {
							textStyle: {
								color: '#9395AB',
								borderRadius: 3,
								padding: [3, 5]
							},
							formatter: (text) => {
								text = text.replace(/\S{5}/g, function(match) {
									return match + '\n'
								})
								return text
							}
						},
						indicator: this.maxValue,
						nameGap: 5, //文字距离图形的距离
						radius: '80px' //设置雷达图大小
					},
					series: [{

						type: 'radar',
						itemStyle: {
							normal: {
								formatter: (val) => {
									let txt = val;
									if (val.length > 6) {
										txt = val.substr(0, 5) + "...";
									}
									return txt;
								}
							},
						},

						symbolSize: 0,
						data: [{
							value: this.myValue,
							name: '用户个人能力',
							areaStyle: {
								normal: {
									color: '#fedcdd'
								}
							},
							itemStyle: {
								normal: {
									color: "#fedcdd",
									borderColor: "rgba(178,34,34,0)",
									borderWidth: 4,
									lineStyle: {
										color: "#fedcdd",
									},
								},
							},
						}]
					}]
				};

				const dom = echarts.init(document.getElementById('starline'))

				dom.setOption(option);
				window.addEventListener('resize', function() {
					dom.resize();
				});
				this.radar = true
				console.log("雷达图加载成功")
			},
			print() {
				if (this.printCustom && (this.reportMake || !this.getDetailList.length)) {
					this.popReport = true
					setTimeout(item => {
						this.popReport = false
					}, 1000)
				} else {
					window.print();
				}
			},
			checkbtn() {
				this.$router.go(-1);
			},
			//
			getActive() {
				UserApi.getActivityAll().then((res) => {
					if (res.code == 0) {
						console.log(res.data, "学res.data学时详情");
						let data = res.data,
							termHours = [],
							termDetail = [],
							spanArray = [],
							spanIndex = 0;
						data.forEach((item, index) => {
							termHours.push({
								date: item.startYear,
								termName: item.termName,
								termHours: item.termHours,
							});
							spanArray.push([spanIndex, item.hoursRecordList.length]);
							spanIndex = spanIndex + item.hoursRecordList.length;

							if (item.hoursRecordList) {
								item.hoursRecordList.forEach((items, indexs) => {
									if (items.sourceTypeName) {
										termDetail.push({
											id: indexs + items.sourceTypeName,
											date: (new Date(item.termStartTime).getFullYear() ==
													new Date(item.termEndTime).getFullYear() ?
													new Date(item.termStartTime).getFullYear() - 1 :
													new Date(item.termStartTime).getFullYear()) +
												"-" +
												new Date(item.termEndTime).getFullYear() +
												"学年",
											termName: item.termName,
											classifyName: items.classifyName,
											hours: items.hours,
											sourceTypeName: items.sourceTypeName,
											time: items.time,
											sourceType: items.sourceType,
											comment: items.comment,
										});
									}
								});
							}
						});

						let tempArr = [];
						let sum = 0
						for (let i = 0; i < termHours.length; i++) {
							if (tempArr.indexOf(termHours[i].date) === -1) {
								this.afterDataHours.push({
									date: termHours[i].date,
									date1: termHours[i].termName.substring(0, 11),
									termHours: termHours[i].termHours
								});
								tempArr.push(termHours[i].date);
							}
						}
						let obj = {};
						let data5 = []
						termHours.forEach(v => obj[v.date] = obj[v.date] === undefined ? v.termHours * 1 : obj[v.date] + v.termHours *
							1)

						for (let key in obj) {
							this.afterDataHours.forEach(item => {
								if (key == item.date) {
									data5.push({
										date1: item.date1,
										termHours: (obj[key] * 1).toFixed(2)
									})
								}
							})
						}
						this.termHours = data5

						this.termDetail = termDetail;
						this.spanArray = spanArray;
						if (Math.ceil(this.termDetail.length / 12) - 1 > 0) {
							this.count = Math.ceil(this.termDetail.length / 12) - 1;
						}
						this.data2 = this.termDetail.slice(12, this.termDetail.length)
						this.numCount = Math.floor(this.data2.length / 12)

						// 数据处理未完善
						this.activeData = res.data;

					} else {
						this.$message.error(res.msg);
					}
				});
			},
			getDetail() {
				UserApi.detailAll().then((res) => {
					if (res.code == 0) {
            // var isdb = res.data.qualifyList.findIndex(item => item.isQualify == 0)
            // if (isdb <0){
            //   this.isreach = true
            // }else {
            //   this.isreach = false
            // }
            this.avgGpa = res.data.avgGpa
            this.result = res.data.result
            this.finishList = res.data.tags
						let tags = res.data.tags
						var that = this;
						that.users = res.data.user;
            // let a1 = this.users.showSealName1;
            // let a2 = this.users.showSealName2;
            // if (a1){
            //   if (a1.indexOf('&&')!==-1){
            //     let length = a1.length,
            //         indexOf = a1.indexOf('&&');
            //     this.users.showSealName1 = a1.slice(0,indexOf)
            //     this.SwalNameurl1 = a1.slice(indexOf+2,length)
            //   }
            // }
            // if (a2){
            //   if (a2.indexOf('&&')!==-1){
            //     let length = a2.length,
            //         indexOf = a2.indexOf('&&');
            //     this.users.showSealName2 = a2.slice(0,indexOf)
            //     this.SwalNameurl2 = a2.slice(indexOf+2,length)
            //   }
            // }
						that.maxValue = []
						that.myValue = []
						that.fillterData = []

						// 在tags里获取需要的数据
						if (tags.length != 0) {
							tags.forEach((item, index) => {
								that.maxValue.push({
									name: item.name,
									max: item.minHours,
									color: "#9395AB",
								})
                if (this.schoolId!=10710){
                  that.classifyData.push({
                    label: item.name,
                    id: item.userValue,
                    min: item.minHours
                  });
                }else {
                  that.classifyData.push({
                    label: item.name,
                    id: item.userValue,
                    min: item.minHours,
                    minScore: item.minScore,
                    rtScore: item.showUserValue
                  });
                }
								that.myValue.push(item.showUserValue * 1);
								that.schoolValue.push(parseFloat(item.schoolValue));
							});
						}
						// 在tags里获取需要的数据
						let fillterData = [];
						if (this.classifyData) {
							this.classifyData.forEach((item) => {
								if (item.id != 0) {
									fillterData.push({
										name: item.label,
										value: item.id
									});
								} else {
									fillterData.push({
										name: item.label
									});
								}
							});
						}
						that.fillterData = fillterData;
						let data = []
						this.fillterData.forEach((item, index) => {

							if (!item.value) {
								this.show = true
								data.push(item.value)

							}
						})

						if (data.length == this.fillterData.length) {
							this.isShow = 2
						}
						this.loading = false;

						this.initData();
						// this.inCirlce()
					} else {
						this.$message.error(res.msg);
					}
				})


			},
		},
	};
</script>
<style lang="scss" scoped>
.termYears {
  display: flex;
  justify-content: space-between;
}
.gz{
  color: #606774;
  width: 45%;
  height: 209px;
  border: 1px dashed #ECECEC;
  padding: 10px;
  box-sizing: border-box;
  display: flex;
  font-size: 14px;
  flex-direction: column;
  justify-content: flex-end;
  .gz_jd{
    font-size: 16px;
    color: #FF6410;
  }
}
.table_ins {
  border: 1px solid #ececec;
  margin-top: 20px;
  // border: 1px solid #ececec;
}
.table_ins tr th {
  width: 4rem;
  text-align: center;
  color: #3c3d47;
  line-height: 30px;
  font-weight: 400;
}

.table_ins tr td {
  padding-top: 10px;
  padding-bottom: 10px;
  color: #606774;
  line-height: 20px;
  text-align: center;
}
	.table_in {
		border: 1px solid #ececec;
		// border: 1px solid #ececec;
		position: relative;
		top: 11px;
	}

	.table_excel {
		border-color: #ececec;
		position: relative;
		top: 11px;
	}

	.table_excel tr th {
		width: 10rem;
		text-align: center;
		color: #3C3D47;
		line-height: 30px;
		font-weight: 400;

	}

	.table_in tr th {
		width: 10rem;
		text-align: center;
		color: #3C3D47;
		line-height: 30px;
		font-weight: 400;

	}

	.table_in tr td {
		color: #606774;
		line-height: 29px;
		text-align: center;
		font-size: 14px;
	}

	.table_excel tr td {
		color: #606774;
		line-height: 18px;
		text-align: center;
		height: 49px;
		font-size: 13px;
		border-bottom: 0;
		border-right: 0;
	}

	.el-table .cell {
		height: 27px !important;
		overflow: hidden;
	}

	.sureProject {
		font-size: 13px;
		text-align: left;
		line-height: 17px;
		padding: 0 5px;
	}

	.load {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 1050px;
		z-index: 999;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.allReport {
		width: 100%;
		// background: rgb(247, 247, 249);
		height: 100%;
		padding-bottom: 20px;
	}

	//new
	.top-content {
		height: 150px;
		display: flex;
		align-items: center;
		align-items: center;
		align-items: flex-start;

		.avatar {
			text-align: left;
			padding: 0px;
			position: absolute;
			left: 30px;

			.img {
				margin-top: 7px;
				height: 50px;
			}

			.zn-university {
				letter-spacing: 8px;
			}
		}

		.title_line {
			font-size: 25px;
			display: flex;
			margin: 0 auto;
			flex-direction: column;
			color: #222;
		}

		.english {
			margin-top: 10px;
			font-size: 12px;
			color: rgb(191, 194, 204);
		}
	}

	.student-base {
		margin: 0px auto;
		width: 700px;
		height: 130px;
		padding: 20px 0px;
		position: relative;
		top: -60px;
		border-bottom: 1px#ececec dashed;
    border-top: 1px#ececec dashed;

		.score {
			position: absolute;
			right: 26px;
			top: 12px;
			color: red;
			font-size: 13px;
		}

		.basic-info {
			width: 300px;
			text-align: left;
			line-height: 30px;
			font-size: 14px;
		}

		.score-info {
			text-align: left;
			line-height: 30px;
			font-size: 14px;
		}
	}

	.home-info {
		margin: 0px auto;
		width: 700px;
		position: relative;
		top: -40px;

		.title-img-info {
			color: #08080D;
			text-align: left;
			font-size: 18px;
			border-bottom: 1px solid #ececec;
			padding-bottom: 10px;
			margin-bottom: 10px;
		}

		.pop-info {
			position: relative;

			.icon {
				right: -7px;
				top: -12px;
				position: absolute;
				transform: rotate(270deg);

				i {
					font-size: 20px;
					color: #0bd699;
				}
			}

			.pop-container {
				.all {
					width: 300px;
					height: 30px;
					margin-left: 20px;
					text-align: center;
					position: relative;
					bottom: 4px;
				}

				.tint {
					position: relative;
					left: -20px;
					width: 150px;
					height: 30px;
					line-height: 30px;
					color: #fff;
				}

				.pop-breif {
					background: url(../images/z1.png) no-repeat;
					background-size: 100% 100%;
				}

				.data-breif {
					background: url(../images/z2.png) no-repeat;
					background-size: 100% 100%;
				}

				.ability-breif {
					background: url(../images/z3.png) no-repeat;
					background-size: 100% 100%;
				}

				.details {
					height: 90px;
					margin: 20px 0px 20px 20px;
					background: #f4f4f4;

					.evaluation {
						padding: 20px;

						p {
							margin: 0px;
						}
					}
				}

				.data-details {
					height: 120px;
					margin: 20px 0px 20px 20px;

					.evaluation {
						padding: 20px;

						p {
							margin: 0px;
						}
					}
				}

				.chart-table {
					color: #fab30f;

					.star-eva {
						i {
							font-size: 30px;
						}
					}

					.avg-star {
						margin: 10px 0px;
						display: flex;
						font-size: 13px;
					}
				}
			}
		}
	}

	.second-page {
		width: 700px;
		padding: 10px 30px 10px 30px;
		height: 1050px;
		overflow: hidden;
		margin: 0 auto;
		background: #fff;
		top: 65px;
		position: relative;
		box-sizing: content-box;
		box-shadow: 0px 0px 10px 0px #eee;

		.sem-section {
			.first-form {
				color: #018e85;
			}

			.first-sem {
				background: #018e85;
			}

			.second-form {
				color: #23ae94;
			}

			.second-sem {
				background: #23ae94;
			}

			.third-form {
				color: #4f9fd2;
			}

			.third-sem {
				background: #4f9fd2;
			}

			.four-form {
				color: #03acd9;
			}

			.four-sem {
				background: #03acd9;
			}

			.five-form {
				color: #65ba81;
			}

			.five-sem {
				background: #65ba81;
			}

			.six-form {
				color: #7f7ed0;
			}

			.six-sem {
				background: #7f7ed0;
			}

			.semester {
				display: flex;
				align-items: center;
				margin: 0 auto;
				width: 200px;

				.text {
					//  margin: 0px 10px;
					font-size: 20px;
				}

				.circle1 {
					margin: 0px 2px;
					width: 8px;
					height: 8px;
					border-radius: 50%;
				}

				.circle2 {
					margin: 0px 2px;
					width: 10px;
					height: 10px;
					border-radius: 50%;
				}

				.circle3 {
					margin: 0px 2px;
					width: 12px;
					height: 12px;
					border-radius: 50%;
				}
			}
		}

		.sem-footer {
			position: absolute;
			width: 1050px;
			bottom: 100px;
			margin: 0px 40px 20px 40px;
			color: #037c3b;
			border-bottom: 1px dashed #037c3b;

			.footer-icon {
				top: 20px;
				left: -15px;
				position: absolute;
				transform: rotate(90deg);

				i {
					font-size: 20px;
					color: #0bd699;
				}
			}
		}
	}

	.id-photo {
		width: 89px;
		height: 112px;
		position: relative;
		object-fit: cover;
		top: 7px;
	}

	.reporthead-photo {
		position: relative;
    margin-right: 70px;
		.icon_img {
			position: absolute;
			bottom: -7px;
			right: -10px;
			width: 1.4rem;
		}
	}
  .ba{
    padding: 5px 0;
  }

	.tag_title {
		color: #BAB7BD;
		padding-right: 5px;
	}

	.first-pagereport {
		width: 700px;
		padding: 10px 30px 10px 30px;
		height: 1050px;
		overflow: hidden;
		margin: 0 auto;
		background: #fff;
		position: relative;
		-webkit-box-sizing: content-box;
		box-sizing: content-box;
		-webkit-box-shadow: 0px 0px 10px 0px #eee;
		box-shadow: 0px 0px 10px 0px #eee;
    background: url(../images/reput_@.png) repeat center #fff;
	}

	.el-table,
	.el-table__expanded-cell,
	.el-table th {
		border-bottom: 1px solid #F1F1F5 !important;
		background: #F1F1F5;
		font-weight: 500;
		color: #3C3D47;
	}

	@media print {
		.student-base {
			margin: 0px auto;
			width: 700px;
			height: 130px;
			padding: 20px 0px;
			position: relative;
			top: -60px;
			border-bottom: 1px#ececec dashed;
    border-top: 1px#ececec dashed;

			.score {
				position: absolute;
				right: 26px;
				top: 12px;
				color: red;
				font-size: 13px;
			}

			.basic-info {
				width: 300px;
				text-align: left;
				line-height: 30px;
				font-size: 14px;
			}

			.score-info {
				text-align: left;
				line-height: 30px;
				font-size: 14px;
			}
		}

		.table_in tr th {
			width: 10rem;
			text-align: center;
			color: #3C3D47;
			line-height: 30px;
			font-weight: 400;

		}

		.el-table,
		.el-table__expanded-cell,
		.el-table th {
			border-bottom: 1px solid #F1F1F5 !important;
			background: #F1F1F5;
			font-weight: 500;
			color: #3C3D47;
		}

		/* .container-reportnew{-webkit-print-color-adjust: exact;} */
		//  .sub-title::before{-webkit-print-color-adjust: exact;}
		@page {
			// margin: 0mm auto;
			//  margin: 3mm;
			margin: 0mm;
		}

		.el-switch {
			display: none !important;
		}

		.showtips {
			display: none !important;
		}

		.pop-text {
			display: none !important;
		}

		.report_cover {
			display: none !important;
		}

		.report-lists {
			display: table !important;
		}

		.report-but {
			display: none !important;
		}

		.report_choose {
			display: none !important;
		}

		.allReport {
			padding-bottom: 0px !important;
		}

		.top-content {
			margin: 0mm;
		}

		.btn {
			display: none;
		}
	}

	.top_img {
	width: 20px;
    height: 20px;
		position: relative;
		top: 5px;
		margin-right: 0.2rem;
	}

	.seal {
		width: 309px;
		height: 140px;
		float: right;
		bottom: 100px;
		display: flex;
		justify-content: space-around;
		right: 40px;
		align-items: center;

	}

  .seal .seal-center {
    //  line-height: 112px;
    font-size: 15px;
    text-align: center;
    color: #606774;
    position: relative;
    .seal_name{
      position: relative;
      z-index: 99;
    }
    .seal_img1{
      width: 120px;
    }
    .seal_img2{
      width: 120px;
    }
  }

	.seal .seal-bottom {
		line-height: 9px;
		text-align: right;
		padding-right: 30px;
	}

	.bottom-line {
		display: flex;
		justify-content: space-between;
		align-items: center;
		position: absolute;
		width: 90%;
		bottom: 10px;
	}

	.bottom-line p {
		height: 1px;
		width: 30%;
		background: #ececec;
	}

	.bottom-line span {
		color: #BFC2CC;
		font-size: 10px;
	}

	.bottom-line div {
		display: flex;
		justify-content: center;
		align-items: center;
	}

	/deep/.el-table .cell {
		//   height:25px !important;
		padding-left: 0 !important;
	}

	.el-table--enable-row-transition .el-table__body td {
		height: 38px !important;
	}

	.report-change .el-tabs__item {
		font-size: 20px;
		height: 50px;
	}

	/deep/ .el-table th {
		background: #F1F1F5 !important;
		color: white;
	}

	#box2 /deep/ .el-table thead {
		display: none;
	}

	/deep/.el-table th .cell {
		color: #3C3D47 !important;
	}

	.el-table td {
		padding: 5px 0 !important;
		line-height: 16px !important;
	}

	.el-table--enable-row-transition .el-table__body td {
		transition: background-color .25s ease;
		padding: 0 !important;
	}

	.el-table .cell {
		line-height: 16px !important;
		padding-right: 10px;

	}

	/deep/.el-loading-spinner i {
		color: #0bd699 !important;
	}

	/deep/.el-loading-spinner .el-loading-text {
		color: #0bd699 !important;
	}

	/deep/.el-table td .cell {
		height: 57px !important;
	}

	/deep/.el-table td,
	.el-table th {
		padding: 5px 0 !important;
		min-width: 0;
		box-sizing: border-box;
		text-overflow: ellipsis;
		vertical-align: middle;
		position: relative;
		text-align: left;
	}

	/deep/.el-button--goon:focus,
	.el-button--goon:hover {
		background: #ebfff9 !important;
		border-color: #0bd699 !important;
		color: #0bd699 !important;
	}

	/deep/.el-button--goon.is-active,
	.el-button--goon:active {
		background: #ebfff9 !important;
		border-color: #0bd699 !important;
		color: #0bd699 !important;
	}

	/deep/.el-button--goon {
		color: #fff;
		background-color: #0bd699;
		border-color: #0bd699;
	}

	/deep/.el-button--cancelIt.is-active,
	.el-button--cancelIt:active {
		color: #BFC2CC;
		background-color: #F5F6F7;
		border-color: #F5F6F7;
	}

	/deep/.el-button--cancelIt:focus,
	.el-button--cancelIt:hover {
		color: #BFC2CC;
		background-color: #F5F6F7;
		border-color: #F5F6F7;
	}

	/deep/.el-button--cancelIt {
		color: #BFC2CC;
		background-color: #F5F6F7;
		border-color: #F5F6F7;
	}

	.noData {
		position: absolute;
		top: 10%;
		height: 50%;
		justify-content: center;
		font-size: 14px;
		color: #646566;
		align-items: center;
		right: 2vh;
		text-align: center;
		display: flex;
		flex-direction: column;
	}

	.noData img {
		width: 300px;
		height: 200px;
		position: relative;
		top: 49px;
	}

	.report_line {
		position: relative;
		top: 0px;
		font-size: 14px;
		color: #BFC2CC
	}

	.report_choose {
		width: 20px;
		height: 20px;
		border: 1px solid #E4E0E0;
		display: inline-block;
		border-radius: 50%;
	}

	.report_cover {
		display: flex;
		flex-direction: column;
		justify-content: space-around;
		position: relative;
		top: 9px;
		padding-bottom: 17px;
		left: 9px;
	}

	.report-but {
		position: fixed;
		bottom: 7%;
		left: 45%;
		z-index: 9;

		.el-button {
			box-shadow: 0px 0px 10px 0px rgba(13, 180, 130, 0.2);
		}
	}

	.report-lists {
		display: flex
	}

	/deep/.el-button--reload:focus,
	.el-button--reload:hover {
		background: #ebfff9 !important;
		border-color: #0bd699 !important;
		color: #0bd699 !important;
	}

	/deep/.el-button--reload.is-active,
	.el-button--reload:active {
		background: #ebfff9 !important;
		border-color: #0bd699 !important;
		color: #0bd699 !important;
	}

	/deep/.el-button--reload {
		color: #0bd699;
		background-color: #fff;
		border-color: #0bd699;
	}

	.pop-text {
		background: #000000;
		opacity: 0.8;
		width: 200px;
		height: 80px;
		font-size: 13px;
		color: rgba(255, 255, 255, .9);
		padding: 0 25px;
		border-radius: 10px;
		position: fixed;
		top: 45%;
		left: 45%;
		z-index: 9;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}

	/deep/.el-switch__label.is-active {
		color: #0bd699 !important;
	}
</style>
